import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { MaterialModule } from '../../../shared/material-module';

import { MetadataSetsComponent } from './metadata-set-tab.component';
import { DialogSetPromptComponent } from './dialog-set-prompt/dialog-set-prompt.component';
import { DialogSetDeleteComponent } from './dialog-set-delete/dialog-set-delete.component';

@NgModule({
  declarations: [
    MetadataSetsComponent,
    DialogSetDeleteComponent,
    DialogSetPromptComponent
  ],
  imports: [CommonModule, MaterialModule, FormsModule],
  exports: [MetadataSetsComponent]
})
export class MetadataSetsModule {}
